import UrlField from './component';
import { UrlFieldProps } from './types';

export type { UrlFieldProps };
export default UrlField;
